import 'arrayq';
import { PureConnect, React } from '../../react';
import Input from 'react-toolbox/lib/input';
import { INote, IParticipant, IUsergroup, isQuestion } from '../../types';
import { notesEditor } from './resource';
import cx from './style.less';
import authSelectors from '../../auth/selectors';
import selectorsParticipantPopup from '../noteParticipantSelectPopup/selectors';
import selectorsCategoryPopup from '../categorySelectPopup/selectors';
import { participantsResource } from '../../participant/resource';
import UPDATE_BUTTON_NO from '../../focuslock/actions/UPDATE_BUTTON_NO';
import SHOW_SELECT_POPUP from '../categorySelectPopup/actions/SHOW';
import SHOW_PARTICIPANT_POPUP from '../noteParticipantSelectPopup/actions/SHOW';
import windowSelectors from '../../window/selectors';
import notesSelector from './selectors';
import { usergroupResource } from '../../usergroup/resource';
import INITIALIZE from './actions/NOTES_INITIALIZE';
import { Btn } from '../../react-toolbox-redesign/button';
import { Category } from '../categorySelectPopup/input';
import { DateTimeText } from '../../shared/date';
import { hack } from '../../browser/launch';
import { notechatEditor } from '../notechat/resource';
const maxNoteTextLength = 3000;
const minLinesVisible = 3;
const maxLinesVisible = 75;

export default PureConnect(`FlyoverNotesEditLayout`)(
    (state) => ({
        creating: notesEditor.selectors.creating(state),
        item: notesEditor.selectors.item(state),
        updating: notesEditor.selectors.updating(state),
        updatingNoteChat: notechatEditor.selectors.updating(state),
        selectNote: state.selection.creating,
        user: authSelectors.user(state),
        allparticipants: participantsResource.selectors.items(state).qSelect((item) => item as IParticipant),
        allparticipantsgroups: usergroupResource.selectors.items(state).qSelect((item) => item as IUsergroup),
        origin: state.notemenu.origin,
        participantPopupVisible: selectorsParticipantPopup.visible(state),
        categoryPopupVisible: selectorsCategoryPopup.visible(state),
        selectTextArea: state.selection.creating,
        screenSmall: windowSelectors.small(state),
        initialized: state.notesReducer.initialize,
        flyoverVisible: state.flyover.visible,
    }),
    (dispatch) => ({
        // cancel: () => dispatch(notesEditor.actions.RESET({})),
        // cancelCreating: () => {
        //     dispatch(notesEditor.actions.CREATE_CANCEL({}));
        // },
        // cancelUpdating: () => {
        //     dispatch(notesEditor.actions.UPDATE_CANCEL({}));
        // },
        change: (item: INote | any) => { dispatch(notesEditor.actions.APPLY({ item })); },
        showCategorySelectPopUp: () => { dispatch(SHOW_SELECT_POPUP({})); },
        showParticipantPopUp: () => { dispatch(SHOW_PARTICIPANT_POPUP({ itemno: -1 })); },
        updateButtonFocus: (buttonNr: number, origin: number, itm: INote) => {
            dispatch(UPDATE_BUTTON_NO({ buttonNo: buttonNr, origin: origin, buttonAction: undefined, lasttoucheditem: itm }));
        },
        initialize: (initialize: boolean) => dispatch(INITIALIZE({ initialize: initialize })),
    }),
    ({ flyoverVisible, creating, updating, updatingNoteChat, selectNote, item, initialized, change, showCategorySelectPopUp, showParticipantPopUp, allparticipants, allparticipantsgroups, participantPopupVisible, categoryPopupVisible, selectTextArea }) => {
        const isquestion = isQuestion(item);
        var visible = flyoverVisible && (creating || updating) && !isquestion && !updatingNoteChat && !selectNote && !participantPopupVisible && !categoryPopupVisible && !selectTextArea;
        var maxlines = maxLinesVisible;
        var selection = document.querySelector('.text-container textarea');
        if (visible && selection && initialized) {
            maxlines = countLines(selection, maxlines);
        }

        var input = <Input
            type="text"
            name="note"
            rows={maxlines}
            value={item.text}
            maxLength={maxNoteTextLength}
            multiline
            className={'text-container'}
            onChange={(value: string) => change({ text: value })}
            floating />;

        return (
            <div className={cx('create_note', (!visible) ? 'wcag-invisible' : '', 'fields-container')}
                aria-hidden={!(visible)}
                aria-labelledby="Maak een notitie aan">
                <title>
                    <span className={cx('title-icon')} data-icon={'icon_message-text'}></span>
                    <span className={cx('title-text')}>{'NOTITIE'}</span>
                </title>
                <div className={cx('note-container')}>
                    <span className={cx('sub-title')}>Uw notitie<span className={cx('important-icon')}>*</span></span>
                    <div id="note" className={cx('input-text-notitie',
                        (item && item.text && item.text.length >= maxNoteTextLength ? 'alert-max-chars' : ''), (flyoverVisible ? 'flyover' : ''))}>
                        {input}
                    </div>
                    <span className={cx('sub-title')}>Categorie</span>
                    {item.categoryId ? <Category categoryId={item.categoryId} /> : null}
                    <Btn
                        type="button"
                        className={'btn'}
                        extraClassNames={'secondary-btn'}
                        aria-label={'Categorie selectie'}
                        aria-haspopup={false}
                        tabIndex={0}
                        onClick={() => { if (!categoryPopupVisible) { showCategorySelectPopUp(); } }}
                    >
                        <span>{item.categoryId ? 'WIJZIGEN' : 'SELECTEER'}</span>
                    </Btn>
                    <span className={cx('sub-title')}>Notitie delen</span>
                    <div className={cx('list-of-shared')}>
                        {item && item.noteParticipantsIDs && item.noteParticipantsIDs.length ?
                            item.noteParticipantsIDs.map((itm) => <div key={itm} className={cx('shared-div')}><span className={cx('icon-shared')}></span>{mapParticipantName(itm, allparticipants)}</div>)
                            : null
                        }
                        {item && item.noteParticipantGroupIDs && item.noteParticipantGroupIDs.length ?
                            item.noteParticipantGroupIDs.map((itm) => <div key={itm} className={cx('shared_multiple-div')}><span className={cx('icon-shared_multiple')}></span>{mapGroupName(itm, allparticipantsgroups)}</div>)
                            : null
                        }
                    </div>
                    <Btn
                        type="button"
                        className={'btn'}
                        extraClassNames={'secondary-btn'}
                        aria-label={'Notities delen met'}
                        aria-haspopup={false}
                        onClick={() => { if (!participantPopupVisible) { showParticipantPopUp(); } }}
                        tabIndex={0}
                    >
                        <span>{item && item.noteParticipantsIDs && item.noteParticipantsIDs.length || item && item.noteParticipantGroupIDs && item.noteParticipantGroupIDs.length ? 'WIJZIGEN' : 'SELECTEER'}</span>
                    </Btn>
                </div>

            </div>

        );
    });

export const ModalNotesEditLayout = PureConnect(`ModalNotesEditLayout`)(
    (state) => ({
        creating: notesEditor.selectors.creating(state),
        item: notesEditor.selectors.item(state),
        updating: notesEditor.selectors.updating(state),
        updatingNoteChat: notechatEditor.selectors.updating(state),
        selectNote: state.selection.creating,
        user: authSelectors.user(state),
        allparticipants: participantsResource.selectors.items(state).qSelect((item) => item as IParticipant),
        allparticipantsgroups: usergroupResource.selectors.items(state).qSelect((item) => item as IUsergroup),
        origin: state.notemenu.origin,
        participantPopupVisible: selectorsParticipantPopup.visible(state),
        categoryPopupVisible: selectorsCategoryPopup.visible(state),
        selectTextArea: state.selection.creating,
        screenSmall: windowSelectors.small(state),
        initialized: state.notesReducer.initialize,
        flyoverVisible: state.flyover.visible,
    }),
    (dispatch) => ({
        change: (item: INote | any) => { dispatch(notesEditor.actions.APPLY({ item })); },
        showCategorySelectPopUp: () => { dispatch(SHOW_SELECT_POPUP({})); },
        showParticipantPopUp: () => { dispatch(SHOW_PARTICIPANT_POPUP({ itemno: -1 })); },
        updateButtonFocus: (buttonNr: number, origin: number, itm: INote) => {
            dispatch(UPDATE_BUTTON_NO({ buttonNo: buttonNr, origin: origin, buttonAction: undefined, lasttoucheditem: itm }));
        },
        initialize: (initialize: boolean) => dispatch(INITIALIZE({ initialize: initialize })),
    }),
    ({ creating, updating, updatingNoteChat, flyoverVisible, selectNote, item, initialized, initialize, change, showCategorySelectPopUp, showParticipantPopUp, allparticipants, allparticipantsgroups, participantPopupVisible, categoryPopupVisible, selectTextArea }) => {

        const isquestion = isQuestion(item);
        var visible = !flyoverVisible && (creating || updating) && !isquestion && !updatingNoteChat && !selectNote && !participantPopupVisible && !categoryPopupVisible && !selectTextArea;
        var maxlines = maxLinesVisible;
        var selection = document.querySelector('.text-container textarea');
        if (visible && selection && initialized) {
            maxlines = countLines(selection, maxlines);
        }

        var input = <Input
            type="text"
            name="note"
            rows={maxlines}
            value={item.text}
            maxLength={maxNoteTextLength}
            multiline
            className={'text-container'}
            onChange={(value: string) => change({ text: value })}
            floating />;

        return (
            <div className={cx('create_note', 'details', (!visible) ? 'wcag-invisible' : '', 'fields-container')}
                aria-hidden={!(visible)}
                aria-labelledby="Maak een notitie aan">
                <section role="content-info" className={cx('content-container')}>
                    <div className={cx('details-top-container')}>
                        <div className={cx('details-title-container')}>
                            <span className={cx('title-text-action')}>{'Notitie wijzigen'}</span>
                            <div className={cx('icon-left-container')}>
                                <span className={cx('icon-container', 'message' )} ></span>
                            </div>
                            <div className={cx('text-created-container')}>
                                <div className={cx('text-created-container-top')}>{'NOTITIE'}</div>
                                <div className={cx('text-created-container-bottom')}><DateTimeText date={item.created} /></div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className={cx('details-content-container')}>
                    <div className={cx('middle-container')}>
                        <div className={cx('made-by-container')}>
                            <div className={cx('text-created-container-top')}>Aangemaakt door</div>
                            <div className={cx('text-created-container-bottom')}>{mapParticipantName(item.userId, allparticipants)}</div>
                        </div> 
                    </div>
                    <div className={cx('edit-category-container')}>
                        <span className={cx('sub-title')}>Categorie</span>
                        {item.categoryId ? <Category extraClassNames={'edit-selected-category'} categoryId={item.categoryId} /> : null}
                        <Btn
                            type="button"
                            className={'btn'}
                            extraClassNames={'secondary-btn'}
                            aria-label={'Categorie selectie'}
                            aria-haspopup={false}
                            tabIndex={0}
                            onClick={() => { if (!categoryPopupVisible) { showCategorySelectPopUp(); } }}
                        >
                            <span>{item.categoryId ? 'WIJZIGEN' : 'SELECTEER'}</span>
                        </Btn>
                    </div>
                    <div className={cx('edit-shared-container')}>
                        <span className={cx('sub-title')}>Notitie delen</span>
                        <div className={cx('list-of-shared')}>
                            {item && item.noteParticipantsIDs && item.noteParticipantsIDs.length ?
                                item.noteParticipantsIDs.map((itm) => <div key={itm} className={cx('shared-div')}><span className={cx('icon-shared')}></span>{mapParticipantName(itm, allparticipants)}</div>)
                                : null
                            }
                            {item && item.noteParticipantGroupIDs && item.noteParticipantGroupIDs.length ?
                                item.noteParticipantGroupIDs.map((itm) => <div key={itm} className={cx('shared_multiple-div')}><span className={cx('icon-shared_multiple')}></span>{mapGroupName(itm, allparticipantsgroups)}</div>)
                                : null
                            }
                        </div>
                        <Btn
                            type="button"
                            className={'btn'}
                            extraClassNames={'secondary-btn'}
                            aria-label={'Notities delen met'}
                            aria-haspopup={false}
                            onClick={() => { if (!participantPopupVisible) { showParticipantPopUp(); } }}
                            tabIndex={0}
                        >
                            <span>{item && item.noteParticipantsIDs && item.noteParticipantsIDs.length || item && item.noteParticipantGroupIDs && item.noteParticipantGroupIDs.length ? 'WIJZIGEN' : 'SELECTEER'}</span>
                        </Btn>
                    </div>
                    <div className={cx('note-container', 'edit-note-container')}>
                        <span className={cx('sub-title')}>Uw notitie<span className={cx('important-icon')}>*</span></span>
                        <div id="note" className={cx('input-text-notitie',
                            (item && item.text && item.text.length >= maxNoteTextLength ? 'alert-max-chars' : ''))}>
                            {input}
                        </div>
                    </div>
                    
                </section>

            </div>

        );
    });

export const NotesSaveArea = PureConnect(`NotesSaveArea`)(
    (state) => ({
        creating: notesEditor.selectors.creating(state),
        item: notesEditor.selectors.item(state),
        updating: notesEditor.selectors.updating(state),
        updatingNoteChat: notechatEditor.selectors.updating(state),
        selectNote: state.selection.creating,
        user: authSelectors.user(state),
        allparticipants: participantsResource.selectors.items(state).qSelect((item) => item as IParticipant),
        allparticipantsgroups: usergroupResource.selectors.items(state).qSelect((item) => item as IUsergroup),
        origin: state.notemenu.origin,
        participantPopupVisible: selectorsParticipantPopup.visible(state),
        categoryPopupVisible: selectorsCategoryPopup.visible(state),
        selectTextArea: state.selection.creating,
        screenSmall: windowSelectors.small(state),
        isminimized: notesSelector.isminimized(state),
    }),
    (dispatch) => ({
        cancel: () => dispatch(notesEditor.actions.RESET({})),
        cancelCreating: () => {
            dispatch(notesEditor.actions.CREATE_CANCEL({}));
        },
        cancelUpdating: () => {
            dispatch(notesEditor.actions.UPDATE_CANCEL({}));
        },
        saveCreating: (item: INote, user: IParticipant) => {
            // item.breadcrumb = getBreadcrumb() ? getBreadcrumb() : '>';
            item = fixNoteDevelopmentJsonServer(item, true);
            dispatch(notesEditor.actions.CREATE_CONTINUE({ item }));
        },
        saveUpdating: (item: INote, user: IParticipant) => {
            item = fixNoteDevelopmentJsonServer(item, false);
            dispatch(notesEditor.actions.UPDATE_CONTINUE({ item }));
        },

    }),
    ({ creating, updating, updatingNoteChat, selectNote, item, user, saveCreating, cancelCreating, saveUpdating, cancelUpdating, participantPopupVisible, categoryPopupVisible, selectTextArea }) => {
        var visible = (creating || updating) && !(isQuestion(item)) && !updatingNoteChat && !selectNote && !participantPopupVisible && !categoryPopupVisible && !selectTextArea;
        return (
            <div className={cx('bottom-panel', (!visible) ? 'wcag-invisible' : '')}
                aria-hidden={!(visible)}
                aria-labelledby="Maak een notitie aan">
                {/* WCAG (button):
                            1) no role; they are buttons
                            2) focussable (Tab)
                            3) toggle function: n/a (when true use aria-checked)
                            4) aria-expanded: n/a
                            5) aria-haspopup: n/a  
                            6) aria-labelledby/aria-describedby: ref to label
                            7) icon of button is explained by tekst-> aria-hidden*/}
                <div className={cx('bottom-buttons')}>
                    <div className={cx('buttons-container', participantPopupVisible || categoryPopupVisible ? 'wcag-invisible' : '')}>
                        <Btn
                            type="button"
                            className={'btn'}
                            extraClassNames={'secondary-btn'}
                            aria-label={'Annuleren'}
                            aria-haspopup={false}
                            tabIndex={0}
                            onKeyDown={(evt: any) => {
                                handleEnters(evt,
                                    creating ?
                                        () => { cancelCreating(); } :
                                        () => { cancelUpdating(); });
                            }}
                            onClick={creating ?
                                () => { cancelCreating(); } :
                                () => { cancelUpdating(); }}
                        >
                            <span>Annuleren</span>
                        </Btn>

                        <Btn
                            type="button"
                            className={'btn'}
                            aria-label={'Opslaan'}
                            aria-haspopup={false}
                            tabIndex={item.text ? 0 : -1}
                            disabled={!item.text}
                            onKeyDown={(evt: any) => {
                                handleEnters(evt, creating ?
                                    () => saveCreating(item, user) :
                                    () => saveUpdating(item, user));
                            }}
                            onClick={creating ?
                                () => saveCreating(item, user) :
                                () => saveUpdating(item, user)}
                        >
                            <span>Opslaan</span>
                        </Btn>
                    </div>

                </div>
            </div>

        );
    });

function mapParticipantName(participantId: string, allparticipants: IParticipant[]) {
    const participant = allparticipants.qWhere((item) => participantId === item.id);
    return participant && participant.qAny() ? `${participant[0].name}` : '';
}

function mapGroupName(groupId: string, allparticipantgroups: IUsergroup[]) {
    const group = allparticipantgroups.qWhere((item) => parseInt(groupId) === item.id);
    return group && group.qAny() ? `${group[0].name}` : '';
}

function countLines(textarea: any, max: number) {
    var buffer = null;
    if (buffer == null) {
        buffer = document.createElement('textarea');
        buffer.style.border = 'none';
        buffer.style.height = '0';
        buffer.style.overflow = 'hidden';
        buffer.style.padding = '0';
        buffer.style.position = 'absolute';
        buffer.style.left = '0';
        buffer.style.top = '0';
        buffer.style.zIndex = '-1';
        buffer.rows = max;
        document.body.appendChild(buffer);
    }

    var cs = window.getComputedStyle(textarea, '');
    var pl = parseInt(cs.paddingLeft);
    var pr = parseInt(cs.paddingRight);
    var lh = parseInt(cs.lineHeight);

    // [cs.lineHeight] may return 'normal', which means line height = font size.
    if (isNaN(lh)) lh = parseInt(cs.fontSize);

    // Copy content width.
    buffer.style.width = (textarea.clientWidth - pl - pr) + 'px';

    // Copy text properties.
    buffer.style.font = cs.font;
    buffer.style.letterSpacing = cs.letterSpacing;
    buffer.style.whiteSpace = cs.whiteSpace;
    buffer.style.wordBreak = cs.wordBreak;
    buffer.style.wordSpacing = cs.wordSpacing;
    buffer.style.wordWrap = cs.wordWrap;

    // Copy value.
    buffer.value = textarea.value;

    var result = Math.floor(buffer.scrollHeight / lh);

    if (result === 0) result = 1;
    if (result <= minLinesVisible) { 
        return minLinesVisible;
    } else if (result > minLinesVisible && result < maxLinesVisible) { 
        return result + 1;
    } else { 
        return maxLinesVisible; }

    // return result <= minLinesVisible ? minLinesVisible : maxLinesVisible;
}

function fixNoteDevelopmentJsonServer(item: INote, create: boolean) {

    return item;
}

function handleEnters(evt: any, funct: () => void) {
    if (evt.key === 'Enter') { evt.preventDefault(); funct(); }
}   



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/notes/noteEditArea.tsx